angular.module('empower.lodgeClaim').constant('lodgeClaimConst', {
  ICARE_LODGE_CLAIM_URL: 'https://portal.icare.nsw.gov.au/claim/lodgement/preliminary-info/'
});
